import type { GetLessonTeachingAndLearningSequenceQuery } from './teaching-notes.graphql.generated';
import AccordionToggleNew from 'approot/shared/accordion/accordion-toggle-new';
import { SecondaryButtonAndIconLink } from 'approot/shared/styles/buttons/secondary-button.style';
import { Box } from 'approot/shared/design-system/box/box.style';
import IconExpand from 'approot/shared/icons/icon-expand';
import type { Pluck } from 'lib/gql/pluck';

const TeachingNotesMetaDataItem = ({
  title,
  items,
  displayExpanded,
}: {
  title: string;
  items: Pluck<
    GetLessonTeachingAndLearningSequenceQuery,
    'getLessonTeachingAndLearningSequence.highImpactTeachingStrategiesDetails'
  >[];
  displayExpanded?: boolean;
}) => {
  return (
    <AccordionToggleNew
      title={title}
      withDividers
      displayExpanded={displayExpanded}
    >
      <Box $gap={8}>
        {items.map(e => (
          <SecondaryButtonAndIconLink
            to={e.link}
            key={e.id}
            $isSmall
            target="_blank"
            aria-label={`${title}: ${e.name}. Read more in a new tab.`}
          >
            {e.name}
            <IconExpand width={20} height={20} />
          </SecondaryButtonAndIconLink>
        ))}
      </Box>
    </AccordionToggleNew>
  );
};

export default TeachingNotesMetaDataItem;
